import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { notyf } from '../utils/Notyf'; 

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(localStorage.getItem('authToken') || null);
  const [userLoaded, setUserLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (authToken) {
      try {
        const decodedUser = jwtDecode(authToken);
        setUser(decodedUser);
      } catch (err) {
        // console.error("Token decode error:", err);
        setAuthToken(null);
        localStorage.removeItem('authToken');
      }
    }
    setUserLoaded(true);
  }, [authToken]);

  const loginUser = async (email, password) => {
    try {
      const response = await fetch('https://blog-app-2-v2of.onrender.com/users/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        setAuthToken(data.access);
        const decoded = jwtDecode(data.access);
        setUser(decoded);
        localStorage.setItem('authToken', data.access);
        notyf.success('Logged in successfully!');
        navigate('/');
      } else {
        let errorMessage = 'Login failed';
  
        // Check for error field first (backend style)
        if (data.error) {
          errorMessage = data.error;
        } else if (data.message) {
          errorMessage = data.message;
        }
  
        throw new Error(errorMessage);
      }
    } catch (error) {
      notyf.error(error.message || 'Something went wrong. Please try again.');
    }
  };  
  
  const logoutUser = () => {
    setAuthToken(null);
    setUser(null);
    localStorage.removeItem('authToken');
    notyf.success('Logged out successfully!');
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ user, authToken, loginUser, logoutUser, userLoaded }}>
      {children}
    </AuthContext.Provider>
  );
};
